import React, { useState } from 'react';
import '../styles/RadioExample.css';

const experienceLevels = [
  {
    id: 'beginner',
    label: 'Beginner',
    description: 'New to programming and automation testing',
  },
  {
    id: 'intermediate',
    label: 'Intermediate',
    description: 'Comfortable with coding and basic test frameworks',
  },
  {
    id: 'advanced',
    label: 'Advanced',
    description: 'Experienced with end-to-end automation and CI/CD',
  },
];

const RadioExample = () => {
  const [selectedLevel, setSelectedLevel] = useState('');

  return (
    <div className="radio-example">
      <h2 className="radio-heading">Radio Buttons</h2>
      <p className="radio-description">
        Select your experience level. Only one option can be selected at a time.
      </p>

      <form className="radio-group" id="radio-buttons">
        {experienceLevels.map((option) => (
          <label key={option.id} htmlFor={`radio-${option.id}`} className="radio-item">
            <input
              type="radio"
              id={`radio-${option.id}`}
              name="experienceLevel"
              value={option.id}
              className="radio"
              checked={selectedLevel === option.id}
              onChange={(event) => setSelectedLevel(event.target.value)}
            />
            <span className="radio-content">
              <span className="radio-label">{option.label}</span>
              <span className="radio-help">{option.description}</span>
            </span>
          </label>
        ))}
      </form>

      {selectedLevel && (
        <p className="radio-selection-summary" id="radio-selection-summary">
          Selected: {experienceLevels.find((option) => option.id === selectedLevel)?.label}
        </p>
      )}
    </div>
  );
};

export default RadioExample;
